import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { CART_CACHE_KEY } from "./keys";

import { CartFilters } from "@/types/cart";
import { CartRepository } from "@/repositories/cart";

export const useGetAllCarts = (filters: CartFilters) => {
  const cartRepository = useRef(new CartRepository());

  return useQuery({
    queryKey: CART_CACHE_KEY.LIST(filters),
    queryFn: async () => {
      return await cartRepository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
